export default "__VITE_ASSET__CMs3HMmX__"